// removed by extract-text-webpack-plugin
module.exports = {"auto-translate-button":"src-lib-components-__AutoTranslateButton__auto-translate-button--1iiWa"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/AutoTranslateButton.less
// module id = 1850
// module chunks = 0